import { Step } from "../atoms/step";

export function LessonStepBar({activeStep}){
    return(
        <div className="horizontal">
            <Step
                step={1}
                finished={activeStep>1}
                active={(1 == activeStep)}
                title={"Cursus info"}
            />
            <Step
                step={2}
                finished={activeStep>2}
                active={(2 == activeStep)}
                title={"Maak les"}
            />
            <Step
                step={3}
                active={(3 == activeStep)}
                finished={activeStep>3}
                title={"Review & Publiceer"}
            />
            
        </div>
    )
}